import React from 'react'
import axios from 'axios'
import ButtonComponent from "../Styles/Form/ButtonComponent"
function Test() {

  const test2 =()=>{
axios.post("192.168.4.1:8080","A00101A2")
.then((res)=>{
  console.log(res)
})
.catch(err=>{
  console.log(err);
})
  }
  return (
    <div>
        <ButtonComponent
                  style={{ width: "50%" }}
                  onClick={() => test2()}
                  value="تست"
                />
    </div>
  )
}

export default Test